
define('ldsh!modules/start/products/email/status/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 product-status-line">\n    ';
 if (productDetails.isRequest) { ;
__p += '\n    <div class="text-center">\n        <i class="ri-loader-4-fill fa-spin product-spinner"></i>\n    </div>\n    ';
 } else { ;
__p += '\n    <div class="row row-same-height">\n        <div class="col-md-12 col-lg-12">\n            <p><b class="i18n" data-i18n="PUBLIC.PRODUCTS.REAL_PLAN"></b>\n                <span data-i18n="ACCOUNTS.STATUS.LANDINGS.LBL_' +
__e(servicePlan.toUpperCase() ) +
'"></span>\n                ';
 if (servicePlan !== "premium") { ;
__p += '\n                 - <a id="email-update-plan"  href="' +
__e(paymentsUrl) +
'" class="i18n ga-tag"\n                                                                                       data-i18n="ACCOUNTS.STATUS.LANDINGS.COMPARE_PLAN"\n                                                                                       data-gacategory="Conversion" data-gaaction="Planes"\n                                                                                       data-galabel="Productos_Link_Email"\n                                                                                       data-gaevent="eventga"></a>\n                ';
 } ;
__p += '\n            </p>\n        </div>\n    </div>\n\n    <div class="row row-same-height">\n        <div class="col-md-12 col-lg-12">\n          <p>\n              <b class="i18n" data-i18n="PUBLIC.PRODUCTS.PRODUCT_LEFT"></b>\n              <span class="product-number">' +
__e(formatNumber(numEmailsAvailable)) +
'</span>\n              <span class="i18n" data-i18n="PUBLIC.PRODUCTS.LBL_EMAILS"></span>\n              ';
 if (servicePlan !== "starter") { ;
__p += '\n              &nbsp;<span style="font-size: 14px;" class="gris i18n" data-i18n="PUBLIC.PRODUCTS.LBL_EMAILS_INFO"></span>\n              ';
 } ;
__p += '\n          </p>\n          ';
 if (dailyEmailsAvailable) { ;
__p += '\n          <p>\n              <b class="i18n" data-i18n="PUBLIC.PRODUCTS.DAILY_PRODUCT_LEFT"></b>\n              <span class="product-number">' +
__e( dailyEmailsRemaining ) +
'/' +
__e( dailyEmailsAvailable ) +
'</span>\n              <span class="i18n" data-i18n="PUBLIC.PRODUCTS.LBL_EMAILS"></span>\n          </p>\n          ';
 } ;
__p += '\n          ';
 if (excessLimitIsOver) { ;
__p += '\n          <p>\n            <b class="i18n red" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.EXCESS"></b>\n            <i class="ayuda-context ri-information-line" tabindex="0" role="button"\n                data-template=\'<div class="popover" role="tooltip" style="width: 400px;max-width: 500px;"><div class="arrow"></div><div class="popover-content helpers-text"></div></div>\'\n                data-toggle="popover" data-i18n="[data-content]ACCOUNTS.STATUS.MDIRECTOR.BALANCE.EXCESS_TOOLTIP"\n                data-trigger="focus"\n                data-i18n-options=\'{"my_rate_payments_links": "' +
__e(billingDataUrl) +
'"}\'\n                data-html="true" data-placement="bottom" data-container="body"></i>\n          </p>\n          ';
 } ;
__p += '\n          ';
 if (emailExcess) { ;
__p += '\n          <p>\n            <b class="i18n" data-i18n="PUBLIC.PRODUCTS.EMAIL_EXCESS_INVOICE"></b>\n            <span class="product-number">' +
__e(formatNumber(emailExcess)) +
'</span>\n          </p>\n          ';
 } ;
__p += '\n        </div>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

